import {addMethod, array, boolean, mixed, number, object, ref, string} from "yup";

addMethod(mixed, 'nullToEmptyString', function () {
    return this.transform((value) => (value === null ? '' : value));
});
addMethod(string, 'nullToEmptyString', function () {
  return this.transform((value) => (value === null ? '' : value));
});

const id = mixed().nullable().notRequired().nullToEmptyString().default('');

export const loginRequestSchema = object({
  email: string().email().required().min(4, ).default(''),
  password: string().required().min(4, ).default(''),
});

export const signupRequestSchema = object({
  name: string().notRequired().min(2).nullable().default(''),
  surname: string().notRequired().min(2).nullable().default(''),
  email: string().required().min(4).email().default(''),
  mobile: string().default(''),
  password: string().required().min(4).default(''),
  password_confirmation: string().oneOf([ref('password'), null], 'Passwords must be the same').default(''),
});

export const changePasswordRequestSchema = object({
  actualPassword: string().required().min(4).default(''),
  newPassword: string().required().min(4).default(''),
  confirmNewPassword: string().oneOf([ref('newPassword'), null], 'Passwords must be the same').default(''),
});

export const changeEmailRequestSchema = object({
  email: string().required().min(4).email().default(''),
  requestEmail: string().required().min(4).email().nullToEmptyString().default(''),
});

export const forgotPasswordRequestSchema = object({
  email: string().email().required().min(4, ).default(''),
});
export const resetPasswordRequestSchema = object({
  password: string().required().min(4, ).default(''),
  password_confirmation: string().oneOf([ref('password'), null], 'Passwords must be the same').default(''),
});

export const userLocationSchema = object({
  id: id,
  lat: mixed().required().nullable().default(''),
  lon: mixed().required().nullable().default(''),
  address: string().required().nullable().nullToEmptyString().min(2).default(''),
  city: string().required().nullable().nullToEmptyString().default(''),
});

export const completeProfileSchema = object({
  name: string().notRequired().min(2).nullable().nullToEmptyString().default(''),
  surname: string().notRequired().min(2).nullable().nullToEmptyString().default(''),
  mobile: string().notRequired().nullable().nullToEmptyString().default(''),
  photo: string().nullToEmptyString().default(''),
  hidden: boolean().default(false),
  searchSlug: string().nullToEmptyString().default(''),
  emailNotifications: boolean().default(true),
  location: userLocationSchema.required().nullable().default(null),
  categories: array().notRequired().default([]),
});

export const userProfileRequestSchema = object({
  id: id,
  name: string().notRequired().min(2).nullable().default(''),
  surname: string().notRequired().min(2).nullable().default(''),
  mobile: string().default(''),
  photo: string().default(''),
  categories: array().notRequired().default([]),
});

export const userProfileNotificationsRequestSchema = object({
  id: id,
  emailNotifications: boolean().default(true),
});

export const searchFilterSchema = object({
  radius: number().nullable().default(2500),
  radiusMetric: string().nullable().default('mi'),
  lat: number().nullable().default(null),
  lon: number().nullable().default(null),
  offset: number().nullable().default(0),
  limit: number().nullable().default(20),
  city: string().nullable().default(null),
  area: string().nullable().default(null),
  address: string().nullable().default(null),
  search: string().nullable().default(null),
  age: string().nullable().default(null),
  datetimeFrom: string().nullable().default(null),
  datetimeTo: string().nullable().default(null),
  duration: string().nullable().default(null),
  daypart: string().nullable().default(null),
  sweatequity: string().nullable().default(null),
  difficulty: string().nullable().default(null),
  sweatmeter: string().nullable().default(null),
  popup: string().nullable().default(null),
  special: string().nullable().default(null),
  categories: string().nullable().default(null),
  excludeCategories: string().nullable().default(null),
});